export const environment = {
    production: true,
    apiUrl: 'https://nuvato.app/api/',
    notificationUrl: 'https://notification.nuvato.app/'
};
